<ngx-spinner bdOpacity=0.9
             bdColor="rgba(51,51,51,0.8)"
             size="large"
             color="#fff"
             type="ball-clip-rotate">
  <p style="color: #fff">Sie werden angemeldet...</p>
</ngx-spinner>

